import api from '.';
import { ServiceAccount, ServiceAccountWithToken } from '@karehero/models';

export const serviceAccountApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllServiceAccount: builder.query<ServiceAccount[], void>({
      query: () => '/service-account',
      providesTags: ['ServiceAccounts'],
    }),
    createServiceAccount: builder.mutation<
      ServiceAccountWithToken,
      ServiceAccount
    >({
      query: (serviceAccount) => ({
        url: '/service-account',
        method: 'POST',
        body: serviceAccount,
      }),
      invalidatesTags: ['ServiceAccounts'],
    }),
    deleteServiceAccount: builder.mutation<ServiceAccount, { id: string }>({
      query: ({ id }) => ({
        url: `/service-account/${id}`,
        method: 'DELETE',
        invalidatesTags: ['ServiceAccounts'],
      }),
    }),
  }),
});

export const {
  useGetAllServiceAccountQuery,
  useCreateServiceAccountMutation,
  useDeleteServiceAccountMutation,
} = serviceAccountApi;

export default serviceAccountApi;
